import axios from 'axios'
import { clone } from '@/util/libUtil.js'

const state = {
	tutorials: [
		{
			id: 1,
			title: 'Tutorial 1: Prueba',
			description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
			url: 'https://drive.google.com/file/d/1xvhSSSmrts-e26UdS4zvNVyga1hVNdd2/preview',
		},
		{
			id: 2,
			title: 'Tutorial 2: Prueba',
			description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
			url: 'https://drive.google.com/file/d/1xvhSSSmrts-e26UdS4zvNVyga1hVNdd2/preview',
		},
		{
			id: 3,
			title: 'Tutorial 3: Prueba',
			description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
			url: 'https://drive.google.com/file/d/1xvhSSSmrts-e26UdS4zvNVyga1hVNdd2/preview',
		},
		{
			id: 4,
			title: 'Tutorial 4: Prueba',
			description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
			url: 'https://www.youtube.com/watch?v=GZUiqTf4jo4',
		},
	]

}

const mutations = {}

const actions = {}

const getters = {}


export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
